import { motion } from "framer-motion";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { HashLink as Link } from "react-router-hash-link";

export default function SupportBanner() {
  return (
    <section className="py-16 text-center">
      <Link smooth to="/supporters#onepercent"> 
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="inline-flex cursor-pointer items-center gap-3 rounded-md bg-blue-900 px-6 py-4 text-white hover:bg-blue-800"
        >
          <span className="font-medium">
            Támogassa Egyesületünket Ön is adója 1%-ának felajánlásával!
          </span>
          <ArrowRightIcon className="h-5 w-5" />
        </motion.div>
      </Link>
    </section>
  );
}